var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35417 1.875V4.16667H6.64583V1.875H4.35417ZM3.89583 0.5C3.38957 0.5 2.97917 0.910406 2.97917 1.41667V4.625C2.97917 5.13126 3.38957 5.54167 3.89583 5.54167H7.10417C7.61043 5.54167 8.02083 5.13126 8.02083 4.625V1.41667C8.02083 0.910406 7.61043 0.5 7.10417 0.5H3.89583ZM1.375 7.83333V10.125H3.66667V7.83333H1.375ZM0.916667 6.45833C0.410406 6.45833 0 6.86874 0 7.375V10.5833C0 11.0896 0.410406 11.5 0.916667 11.5H4.125C4.63126 11.5 5.04167 11.0896 5.04167 10.5833V7.375C5.04167 6.86874 4.63126 6.45833 4.125 6.45833H0.916667ZM7.33333 10.125V7.83333H9.625V10.125H7.33333ZM5.95833 7.375C5.95833 6.86874 6.36874 6.45833 6.875 6.45833H10.0833C10.5896 6.45833 11 6.86874 11 7.375V10.5833C11 11.0896 10.5896 11.5 10.0833 11.5H6.875C6.36874 11.5 5.95833 11.0896 5.95833 10.5833V7.375Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksIcon);
export default __webpack_public_path__ + "static/media/blocks-icon.ace138f44da2b19d53842a0cb08d5e89.svg";
export { ForwardRef as ReactComponent };